import { useEffect, type ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { notificationScopeInvalidationTags, notificationsApi } from '../../api/notifications'
import { useAppDispatch } from '../../hooks/hooks'
import { useNotificationsSse } from '../../hooks/useNotificationsSse'
import { WebPushSubscriptionProvider } from './WebPushSubscriptionProvider'

function NotificationsBootstrapInner() {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  useNotificationsSse()

  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return
    }

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'PROKA_NOTIFICATION') {
        dispatch(notificationsApi.util.invalidateTags(notificationScopeInvalidationTags))
        return
      }
      if (event.data?.type === 'PROKA_NAVIGATE' && typeof event.data.url === 'string') {
        navigate(event.data.url)
      }
    }

    navigator.serviceWorker.addEventListener('message', handleMessage)
    return () => {
      navigator.serviceWorker.removeEventListener('message', handleMessage)
    }
  }, [dispatch, navigate])

  return null
}

export function AuthenticatedNotificationsBootstrap({ children }: { children?: ReactNode }) {
  return (
    <WebPushSubscriptionProvider>
      <NotificationsBootstrapInner />
      {children}
    </WebPushSubscriptionProvider>
  )
}
